import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import DashboardPanelProviderCompletionStats from "root/Dashboard/DashboardPanelProviderCompletionStats";

import DashboardPanelAdminRAGBarStats from "root/Dashboard/DashboardPanelAdminRAGBarStats";
import GlobalContext from "root/Contexts/GlobalContext";

import './DashboardContainer.scss';
import { ConfigOptions } from "root/Contexts/GlobalProvider";

const DashboardContainer = (props) =>{
    const sessionContext = useContext( GlobalContext ) ;
    const survey_type = sessionContext.getCurrentSurveyType() ;

    const admin_title = sessionContext.getCustomObject( ConfigOptions.DASHBOARD_TITLE_COMPLETION_ADMIN ) ;

    const dashboardRows = () => {
        return (
            <Fragment>
                <div key='row1' className='row'>
                    <div className='col-md-12'>
                        <div className='dash-style'>
                            <DashboardPanelProviderCompletionStats title='Audits Completed - All Schools' id={1} survey_type={survey_type}/>
                        </div>
                    </div>
                </div>
                <div key='row2' className='row'>
                    <div className='col-md-12'>
                        <div className='dash-style'>
                            <DashboardPanelAdminRAGBarStats title={admin_title} id={3} survey_type={survey_type} />
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    return dashboardRows();
}

export default DashboardContainer;